import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import palette from '../styles/palette';
import StaticBanner from '../StaticBanner';
import ActionButton from '../Snackbar/Buttons/ActionButton';
import { WarningIcon } from '../icons';

const useStyles = makeStyles(() => ({
  warningContainer: {
    background: palette.slate,
    boxShadow:
      '0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 1px 5px rgba(0, 0, 0, 0.2)',
  },
  warningMessage: {
    color: palette.typography.white.solid,
    padding: '0px 15px',
  },
}));

const WarningBanner = ({ message, onActionClick, actionTitle }) => {
  const classes = useStyles();

  return (
    <StaticBanner
      message={message}
      rootClassName={classes.warningContainer}
      messageClassName={classes.warningMessage}
      MessageIcon={WarningIcon}
    >
      {!!onActionClick && (
        <ActionButton
          className={classes.button}
          bgColor={palette.modalButtons.blue}
          onClick={onActionClick}
        >
          {actionTitle}
        </ActionButton>
      )}
    </StaticBanner>
  );
};

export default memo(WarningBanner);
